import { Flex, Image, Text, Button } from 'rebass';
import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';
import Modal from 'app/modal/v3/index';
import { IoIosArrowRoundBack } from 'react-icons/io';
import ftui from './assets/showftue.png';

function FooterComponent({ disabled, sx = {}, backText = 'Back', onBackDisabled, onBack, nextButtonText, onStepUp, buttonSx = {} }) {
    return <Flex
        width="100%"
        sx={{
            justifyContent: "space-between",
            alignItems: "center",
            px: "26px",
            pt: 2,
            ...sx,
        }}
    >
        {onBack && <Flex
            height={40}
            justifyContent="space-around"
            alignItems="center"
            sx={{ borderRadius: 'medium', cursor: onBackDisabled || !onBack ? 'not-allowed' : 'pointer' }}
            onClick={onBackDisabled || !onBack ? undefined : onBack}
            disabled={onBackDisabled}
        >
            <Text as={IoIosArrowRoundBack} color="mineShaft" minWidth={"24px"} fontSize={24} />
            <Text minWidth={'max-content'} color="mineShaft" fontFamily="Poppins" lineHeight={'150%'} ml={2} fontWeight={400} fontSize="15px">
                {' '}
                {backText}
            </Text>
        </Flex>}

        <Button
            height={40}
            py={1}
            px={5}
            bg={disabled ? "grey" : "brand"}
            onClick={onStepUp}
            sx={{ borderRadius: '23px', opacity: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', ...buttonSx }}
        >
            {nextButtonText}
        </Button>
    </Flex>


}

const MilestonesFTUE = ({ onClose }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        if (modalRef.current)
            modalRef.current.scrollTo(0, 0);
    }, []);

    const renderStep = () => {
        return (
            <Flex m="auto" mt={[2, "50px"]} flexDirection="column" justifyContent="center" alignItems="center" maxWidth={400}
                ref={modalRef}
                maxHeight={["80vh", "100%"]}
                overflow="auto" px={2} mb={7}>
                <Text fontFamily="Bitter" fontWeight="normal"
                    sx={{
                        color: '#000',
                        fontFamily: 'Bitter',
                        fontSize: '30px',
                        fontWeight: '500',
                        lineHeight: '165%',
                    }}
                >
                    Welcome to Your Baby’s Milestones!
                </Text>
                <Text
                    py={2}
                    color="#64748B"
                    fontFamily="Poppins"
                    fontSize="18px"
                    fontStyle="normal"
                    fontWeight={400}
                    lineHeight="200%"
                    letterSpacing="-0.36px"
                    textAlign='left'
                    sx={{
                        '>svg': {
                            marginBottom: '-5px',
                        }
                    }}
                >
                    Click on a milestone to add a date and watch your milestone page grow in your&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        <path d="M18.625 3.12501C16.0921 3.1366 14.3267 3.45527 13.1392 4.02263C12.013 4.5607 11.3991 5.32445 11.125 6.33464V16.0311C12.5489 14.9777 14.732 14.375 18.625 14.375V3.12501ZM19.875 14.375C19.875 14.7065 19.7432 15.0244 19.5088 15.2588C19.2744 15.4932 18.9565 15.625 18.625 15.625C13.699 15.625 12.0058 16.6186 10.9883 17.8906C10.8697 18.0389 10.6899 18.125 10.5 18.125C10.3101 18.125 10.1303 18.0382 10.0117 17.8898C9.00105 16.6254 7.30029 15.625 2.375 15.625C1.99801 15.625 1.66777 15.4651 1.44157 15.1994C1.22346 14.943 1.125 14.6174 1.125 14.2993V3.12501C1.12469 2.96118 1.15699 2.7988 1.2194 2.64731C1.28212 2.49515 1.37403 2.35678 1.4904 2.24041L1.58155 2.1574C1.67663 2.07947 1.78323 2.01643 1.8973 1.96941C2.04952 1.90669 2.21281 1.87439 2.37744 1.87501L2.85921 1.88071C5.22867 1.92833 7.05579 2.25271 8.39958 2.8947C9.33239 3.34038 10.0256 3.93745 10.5 4.67774C10.9744 3.93745 11.6676 3.34038 12.6004 2.8947C14.0338 2.20989 16.0176 1.88669 18.6226 1.87501L18.7454 1.88071C18.8271 1.88847 18.9078 1.9043 18.9863 1.92791L19.1027 1.96941L19.2142 2.02149C19.2865 2.06004 19.3551 2.10544 19.4185 2.1574L19.5096 2.24041L19.5926 2.33155C19.6705 2.42663 19.7336 2.53323 19.7806 2.64731C19.843 2.7988 19.8753 2.96117 19.875 3.12501V14.375ZM2.375 14.2993C2.375 14.3368 2.38187 14.3612 2.38721 14.375C6.26997 14.3763 8.45382 14.9823 9.875 16.0319V6.33464C9.60089 5.32445 8.98704 4.5607 7.86084 4.02263C6.67333 3.45527 4.9079 3.1366 2.375 3.12501V14.2993Z" fill="#64748B" />
                    </svg> <Text as="span" fontWeight={500} color="#64748B" fontFamily="Poppins" fontSize={16} lineHeight="20px" letterSpacing="-0.096px"> Book Preview</Text>
                </Text>
                <FooterComponent
                    sx={{ justifyContent: 'center' }}
                    onStepUp={onClose}
                    nextButtonText="Sounds great!"
                />
            </Flex>
        );
    }

    return (
        <Modal
            maxWidth={620}
            shadeProps={{ pt: [0, 4] }}
            closeOnOutsideClick={false}
            isScrollActive={false}
            aboveTooltip
        >
            {renderStep()}
        </Modal>
    );
};

MilestonesFTUE.defaultProps = {
    title: 'Add Media',
    dividerText: 'other types',
    pagePosition: null,
};

MilestonesFTUE.propTypes = {
    title: PropTypes.string,
    onClose: PropTypes.func.isRequired,
};

export default MilestonesFTUE;
